export type PromotionContent = {
	textDescription: string;
	imgSrc: string;
	url: string;
	id: string;
};

export const CURRENT_PROMOTIONS = [
	{
		textDescription: 'Good Things Festival 2025 - Sign up now! Tool, Weezer, Garbage, All Time Low, Machine Head, The All American Rejects and more',
		imgSrc: require('@/assets/promoted/goodthings25_oztix_600x300.jpg'),
		url: 'https://goodthingsfestival.com.au/?utm_source=oztix&utm_medium=website&utm_campaign=AdSlot_SignUp',
		id: 'good-things-2025-001',
	},
	{
		textDescription: 'Good Things Festival 2025 - Sign up now! Tool, Weezer, Garbage, All Time Low, Machine Head, The All American Rejects and more',
		imgSrc: require('@/assets/promoted/goodthings25_oztix_600x300.jpg'),
		url: 'https://goodthingsfestival.com.au/?utm_source=oztix&utm_medium=website&utm_campaign=AdSlot_SignUp',
		id: 'good-things-2025-002',
	},
];

export const BACKUP_PROMOTIONS = [
	{
		textDescription: '$100 off your first case of wine at Naked Wines',
		imgSrc: require('@/assets/promoted/naked-wines-001-rs.png'),
		url: 'https://www.nakedwines.com.au/ztix100',
		id: 'naked-wines-001',
	},
	{
		textDescription: "Escape to K'Gari (Fraser Island) with Sunrover",
		imgSrc: require('@/assets/promoted/sunrover-tours-001-rs.png'),
		url:
			'https://www.sunrover.com.au/?utm_source=oztix&utm_medium=homepage&utm_content=displayad',
		id: 'sunrover-camping-001',
	},
];
